var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.273 10.0002L15.1191 6.15407L15.9122 5.36092C16.0293 5.24391 16.0293 5.05378 15.9122 4.93678L15.0636 4.08813C14.9466 3.97112 14.7565 3.97112 14.6395 4.08813L10.0002 8.7274L5.36092 4.08775C5.24391 3.97075 5.05378 3.97075 4.93678 4.08775L4.08775 4.9364C3.97075 5.05341 3.97075 5.24354 4.08775 5.36054L8.7274 10.0002L4.08775 14.6395C3.97075 14.7565 3.97075 14.9466 4.08775 15.0636L4.9364 15.9122C5.05341 16.0293 5.24354 16.0293 5.36054 15.9122L10.0002 11.273L13.8463 15.1191L14.6395 15.9122C14.7565 16.0293 14.9466 16.0293 15.0636 15.9122L15.9122 15.0636C16.0293 14.9466 16.0293 14.7565 15.9122 14.6395L11.273 10.0002Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b54b65935207a58e1524e12c0b279210.svg";
export { ForwardRef as ReactComponent };